// pages/Dashboard.jsx
import PrivacyPolicy from "../../components/home/policyComponents/PrivacyPolicy";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <PrivacyPolicy />
    </HomeLayout>
  );
}
